import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AppState } from "@app/app.service";
import { routerTransition } from "@app/shared/utils/animations";
import { EmitService } from "@app/ts/services/emit.service";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styles: [],
  animations: [routerTransition]
})
export class MainLayoutComponent implements OnInit {
  showComponent:boolean = false;
  constructor(private emitService:EmitService,private _appService:AppState) {

  }

  ngOnInit() {}

  getState(outlet) {
    if (!outlet?.activatedRoute) return '';
      return outlet.activatedRouteData?.state || '';
  }

}
